import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

/**
 * A minimal top-level container that organizes multiple <ViewportPane>
 * children in a grid. Typically driven by a layout config.
 */
function ViewportGrid({ numRows, numCols, layoutType, children }) {
  const isPrint = useSelector(state => state.user.isPrint);
  return (
    <div
      data-cy="viewport-grid"
      className={`dark:bg-primary-modalgray border-primary-gray dark:border-primary-newgray rounded-tr-lg rounded-tl-2xl ${isPrint ? 'border-0' : 'border-8'} border-b-0 bg-white p-2`}

      style={{
        position: 'relative',
        height: '100%',
        width: '100%',
      }}
    >
      {children}
    </div>
  );
}

ViewportGrid.propTypes = {
  numRows: PropTypes.number.isRequired,
  numCols: PropTypes.number.isRequired,
  layoutType: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
};

export { ViewportGrid };
